import { render, staticRenderFns } from "./LoginBrand.vue?vue&type=template&id=0489195a&scoped=true&"
import script from "./LoginBrand.vue?vue&type=script&lang=js&"
export * from "./LoginBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489195a",
  null
  
)

export default component.exports